import * as TransferInfo from './components/TransferInfo.css';

export default {
	TransferInfo
};
